// @ts-strict-ignore
import styled from 'styled-components';
import Router from 'next/router';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { LinkButton } from 'styles-js/buttons';
import Icon from 'src/components/icon';

export default function NextPreviousLinks() {
  const { currentModule, details = {}, modules } = useSelector(({ pages }) => pages.programs);
  const { code: programCode } = details;
  const isFirstModule = currentModule?.sort === 1;
  const isLastModule = currentModule?.sort === modules.length;
  const nextModule = modules.find(m => currentModule?.sort === m.sort - 1);
  const previousModule = modules.find(m => currentModule?.sort === m.sort + 1);

  const redirectToProgramPage = (event, programCode, futureModuleCode) => {
    event.preventDefault();
    Router.push(
      `/programs?slug=${programCode}&moduleCode=${futureModuleCode}`,
      `/programs/${programCode}/${futureModuleCode}`,
    );
  };

  return (
    <Wrapper>
      {!isFirstModule && (
        <LinkButton
          as="a"
          href={`/programs/${programCode}/${previousModule.code}`}
          onClick={event => redirectToProgramPage(event, programCode, previousModule.code)}
        >
          <Icon icon="open-left" /> {i18n.t('Previous')}
        </LinkButton>
      )}
      {!isLastModule && (
        <LinkButton
          as="a"
          href={`/programs/${programCode}/${nextModule.code}`}
          onClick={event => redirectToProgramPage(event, programCode, nextModule.code)}
        >
          {i18n.t('Next')} <Icon icon="open-right" />
        </LinkButton>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom:  20px;

  @media (${props => props.theme.underScreenMedium}) {
    margin-bottom:  40px;
  }
`;
